import {Component, OnInit} from '@angular/core';
import {AuthControllerService} from '../../../services/auth-controller/auth-controller.service';
import {AuthRESTService} from '../../services/rest/auth-rest.service';
import {Router} from '@angular/router';
import Commons from 'app/components/pages/commons';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'page-layout',
    templateUrl: './page-layout.component.html',
})
export class PageLayoutWidget extends Commons implements OnInit {
    currentUserIsVerified: boolean;
    pressedVerification: boolean;
    static currentUserIsVerified: boolean;

    static messagesFromAuth: Array<any> = [];

    constructor(private authService: AuthControllerService,
                private rest: AuthRESTService,
                private router: Router,
                toastr: ToastrService,
                translate: TranslateService) {
        super(toastr, translate)
    }

    customAuthorizeMessagesArePresent(){
        return this.customAuthorizeMessages().length > 0
    }

    customAuthorizeMessages(){
        return PageLayoutWidget.messagesFromAuth;
    }

    ngOnInit(): void {
		this.onTokenChanged = this.onTokenChanged.bind(this);
        if (this.authService.isLogged()) {
            this.checkEmailVerification();
        }
        this.authService.subscribeForTokenChange(this.onTokenChanged);
	}

	ngOnDestroy(): void {
		this.authService.unsubscribe(this.onTokenChanged);
	}

	onTokenChanged(): void {
		this.checkEmailVerification();
		if (!this.authService.isSavedTokenValid()) {
			this.router.navigate(['/login/']);
		}
	}

    private checkEmailVerification() {
        this.currentUserIsVerified = PageLayoutWidget.currentUserIsVerified || this.authService.isUserEmailVerified()
    }

    verify() {
        return this.authService.confirmMail().subscribe((response) => {
            PageLayoutWidget.currentUserIsVerified = true;
            this.currentUserIsVerified = true;
            this.pressedVerification = true;
        }, err => this.errorHandler(err))
    }

    closeVerificationAlert() {
        this.pressedVerification = false;
    }

}
